module.exports = __webpack_public_path__ + "static/img/gjj.8485c887.png";